import { render, staticRenderFns } from "./WorldSubMenu.vue?vue&type=template&id=40dac081&scoped=true&"
import script from "./WorldSubMenu.vue?vue&type=script&lang=js&"
export * from "./WorldSubMenu.vue?vue&type=script&lang=js&"
import style0 from "./WorldSubMenu.vue?vue&type=style&index=0&id=40dac081&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../contacts/spa/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40dac081",
  null
  
)

export default component.exports